import { useEffect } from 'react'

/**
 * Calls `handler` when the user presses Escape.
 * Pass `enabled=false` to disable without unmounting.
 */
export function useEscapeKey(handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handler(e)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [handler, enabled])
}
